import { create } from '@terminal/utils/store/createStore';

import { getDefaultInsightsFilterState, InsightsAnalysisType } from './utils';

export type InsightsFilterState = Record<
  string,
  { key: InsightsAnalysisType; checked: boolean }[]
>;

type AssetsTableStore = {
  insightsFilterState: InsightsFilterState;
};

export const useAssetsTableStore = create<AssetsTableStore>(() => ({
  insightsFilterState: getDefaultInsightsFilterState(true, {
    isCompanyCatalystEnabled: true,
    isEarningsInsightsEnabled: true,
  }),
}));
